<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Layout from '@/layouts/MainLayouts.vue';

const route = useRoute();

// Check if current route should use layout
const useLayout = computed(() => {
  return route.meta?.layout !== false;
});
</script>

<template>
  <section class="relative">
    <Layout v-if="useLayout">
      <router-view />
    </Layout>
    <router-view v-else />
  </section>
</template>